import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import javascript from "../assets/images/JavaScript-logo.png";
import mongodb from "../assets/images/mongodb-logo.png";
import reactLogo from "../assets/images/react-svg.png";
import pythonLogo from "../assets/images/python.png";


function Skills(props) {
  return (
    <Container className="m-2">
      <Row style={{ alignItems: "center" }} className="mx-5 my-2">
        <h3>Skills</h3>
        <Col>
          <Image src={javascript} fluid style={{ maxHeight: "180px" }} />
        </Col>
        <Col>
          <Image src={mongodb} fluid style={{ maxHeight: "180px" }} />
        </Col>
        <Col>
          <Image src={reactLogo} fluid />
        </Col>
        <Col>
          <Image src={pythonLogo} fluid />
        </Col>
      </Row>
    </Container>
  );
}

export default Skills;
